module.exports = __webpack_public_path__ + "static/media/descript_ai.a7367171.png";